
import { useState, useEffect } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsApp = () => {
    window.open('https://wa.me/5544999921632?text=Olá! Gostaria de solicitar uma proposta para serviços de engenharia.', '_blank');
  };

  const scrollToSection = (sectionId: string) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center">
              <h1 className={`text-2xl font-bold ${isScrolled ? 'text-black' : 'text-white'}`}>
                Regiane <span className="text-yellow-600">Fialho</span>
              </h1>
            </div>
            
            <nav className="hidden md:flex items-center space-x-8">
              <button onClick={() => scrollToSection('sobre')} className={`${isScrolled ? 'text-gray-700 hover:text-yellow-600' : 'text-white hover:text-yellow-400'} transition-colors cursor-pointer`}>
                Sobre
              </button>
              <button onClick={() => scrollToSection('servicos')} className={`${isScrolled ? 'text-gray-700 hover:text-yellow-600' : 'text-white hover:text-yellow-400'} transition-colors cursor-pointer`}>
                Serviços
              </button>
              <button onClick={() => scrollToSection('experiencia')} className={`${isScrolled ? 'text-gray-700 hover:text-yellow-600' : 'text-white hover:text-yellow-400'} transition-colors cursor-pointer`}>
                Experiência
              </button>
              <button onClick={() => scrollToSection('contato')} className={`${isScrolled ? 'text-gray-700 hover:text-yellow-600' : 'text-white hover:text-yellow-400'} transition-colors cursor-pointer`}>
                Contato
              </button>
            </nav>

            <div className="flex items-center gap-3">
              <Button variant="outline" size="sm" onClick={handleWhatsApp}>
                <i className="ri-whatsapp-line"></i>
                WhatsApp
              </Button>
              <Button size="sm" onClick={() => scrollToSection('contato')}>
                Solicitar Proposta
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* CTA Fixo */}
      <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
        <Button onClick={() => scrollToSection('contato')} className="shadow-2xl">
          <i className="ri-mail-line"></i>
          Solicitar Proposta
        </Button>
        <Button variant="secondary" onClick={handleWhatsApp} className="shadow-2xl">
          <i className="ri-whatsapp-line"></i>
          WhatsApp
        </Button>
      </div>
    </>
  );
}
